import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSkiNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4.905 1.04C5.548-.204 7.32-.226 7.993 1L12 8.293l4.007-7.292c.674-1.227 2.445-1.205 3.088.039l.558 1.08a4 4 0 01-.047 3.763l-4.465 8.127 4.675 8.508A1 1 0 0118.94 24h-4a1 1 0 01-.877-.519L12 19.727 9.937 23.48a1 1 0 01-.876.519h-4a1 1 0 01-.877-1.482L8.86 14.01 4.394 5.883a4 4 0 01-.047-3.763zM9.557 8l-3.09-5.625-.344.663a2 2 0 00.024 1.882L7.839 8zm1.099 2H8.938l1.648 3h1.718zm4.875 12h1.718l-3.846-7h-1.718zm-5.53-5.913L6.75 22h1.718l2.39-4.35zm4-4.154L15.061 10h-1.718l-.203.37zm3.533-9.558L14.444 8h1.717l1.692-3.08a2 2 0 00.024-1.882z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSkiNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSkiNormalSmall;
